import { Language } from '@summer-health/types/locale';
import {
  carePlanItems as enCarePlanItems,
  carePlanTriggers as enCarePlanTriggers,
  milestones as enMilestones,
  partnershipEmails as enPartnershipEmails,
  systemMessages as enSystemMessages,
  medicaidCarriersByState as enMedicaidCarriersByState,
  cards as enCards,
  interstitials as enInterstitials,
  interstitialGroups as enInterstitialGroups,
  forms as enForms,
  errorPages as enErrorPages,
  legalAgreements as enLegalAgreements,
  images as enImages,
  screenings as enScreenings,
  screeningImages as enScreeningImages,
} from './en';
import {
  carePlanItems as esCarePlanItems,
  carePlanTriggers as esCarePlanTriggers,
  milestones as esMilestones,
  partnershipEmails as esPartnershipEmails,
  systemMessages as esSystemMessages,
  medicaidCarriersByState as esMedicaidCarriersByState,
  cards as esCards,
  interstitials as esInterstitials,
  interstitialGroups as esInterstitialGroups,
  forms as esForms,
  errorPages as esErrorPages,
  legalAgreements as esLegalAgreements,
  images as esImages,
  screenings as esScreenings,
  screeningImages as esScreeningImages,
} from './es';

const buckets = {
  carePlanItems: { en: enCarePlanItems, es: esCarePlanItems },
  carePlanTriggers: { en: enCarePlanTriggers, es: esCarePlanTriggers },
  milestones: { en: enMilestones, es: esMilestones },
  partnershipEmails: { en: enPartnershipEmails, es: esPartnershipEmails },
  systemMessages: { en: enSystemMessages, es: esSystemMessages },
  medicaidCarriersByState: {
    en: enMedicaidCarriersByState,
    es: esMedicaidCarriersByState,
  },
  cards: { en: enCards, es: esCards },
  interstitials: { en: enInterstitials, es: esInterstitials },
  interstitialGroups: { en: enInterstitialGroups, es: esInterstitialGroups },
  forms: { en: enForms, es: esForms },
  errorPages: { en: enErrorPages, es: esErrorPages },
  legalAgreements: { en: enLegalAgreements, es: esLegalAgreements },
  images: { en: enImages, es: esImages },
  screenings: { en: enScreenings, es: esScreenings },
  screeningImages: { en: enScreeningImages, es: esScreeningImages },
} as const;

type Buckets = typeof buckets;
type LocaleKey = 'en' | 'es';

const languageToKey: Record<Language, LocaleKey> = {
  [Language.English]: 'en',
  [Language.Spanish]: 'es',
};

export function dataFor<K extends keyof Buckets>(
  bucket: K,
  language: Language = Language.English,
): Buckets[K]['en'] {
  const localeKey = languageToKey[language] ?? 'en';
  return buckets[bucket][localeKey] as Buckets[K]['en'];
}
